import { render, staticRenderFns } from "./TermsAndConditionsContent.vue?vue&type=template&id=5881e1fa&scoped=true"
import script from "./TermsAndConditionsContent.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsContent.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditionsContent.vue?vue&type=style&index=0&id=5881e1fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5881e1fa",
  null
  
)

export default component.exports